// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__hTgUW","headers":"otherPropertyItemNew_headers__-D5Ni","semiTitle":"otherPropertyItemNew_semiTitle__yN8Rt"};